import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  Name: "DarkNovaDark",
};
const Reducer = createSlice({
  name: "Theme",
  initialState,
  reducers: {
    SetTheme(_, action) {
      return {
        Name: action.payload,
      };
    },
    ResetTheme() {
      return { ...initialState };
    },
  },
});

export default Reducer.reducer;
export const { SetTheme, ResetTheme } = Reducer.actions;
